import headerStyles from '../trackfavmenu.module.css';
import { AppBar, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import styles from '../configuremap/configuremap.module.css';
import { closeHeader } from '../actions/HeaderHelper';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as BackIcon } from '../../assets/icons/ic_arrow_back.svg';
import React, { useContext, useRef, useState } from 'react';
import ActionsMenu from '../actions/ActionsMenu';
import WeatherForecastSourceActions from './WeatherForecastSourceActions';
import WeatherLayersActions from './WeatherLayersActions';
import AppContext from '../../context/AppContext';
import WeatherContext from '../../context/WeatherContext';
import { ReactComponent as ForecastSourceIcon } from '../../assets/icons/ic_action_umbrella.svg';
import { ReactComponent as WeatherLayersIcon } from '../../assets/icons/ic_map_configure_map.svg';
import { useTranslation } from 'react-i18next';
import { clearShowDetailsFlag } from '../../manager/WeatherManager';
import IconBtn from '../../frame/components/btns/IconBtn';
import { MAIN_URL_WITH_SLASH, WEATHER_URL, liveHash } from '../../manager/GlobalManager';
import { useLocation, useNavigate } from 'react-router-dom';

export default function WeatherHeader({ setShowInfoBlock = null, isDetails = false }) {
    const ctx = useContext(AppContext);
    const wtx = useContext(WeatherContext);

    const navigate = useNavigate();
    const location = useLocation();

    const { t } = useTranslation();
    const [openForecastActions, setOpenForecastActions] = useState(false);
    const [openLayersActions, setOpenLayersActions] = useState(false);
    const anchorForecastSource = useRef(null);
    const anchorWeatherLayers = useRef(null);

    function getActions(e, anchorEl, setOpenActions) {
        setOpenActions(true);
        ctx.setOpenedPopper(anchorEl);
        e.stopPropagation();
    }

    return (
        <>
            <AppBar position="static" className={headerStyles.appbar}>
                <Toolbar className={headerStyles.toolbar}>
                    <IconBtn
                        id="se-weather-close"
                        variant="contained"
                        type="button"
                        className={styles.closeIcon}
                        onClick={() => {
                            clearShowDetailsFlag(wtx);
                            if (isDetails) {
                                navigate({
                                    pathname: MAIN_URL_WITH_SLASH + WEATHER_URL,
                                    hash: liveHash(),
                                });
                            } else {
                                wtx.setWeatherDate(new Date());
                                wtx.setWeatherLayers((prev) => ({
                                    ...prev,
                                    [wtx.weatherType]: prev[wtx.weatherType].map((l) => ({ ...l, checked: false })),
                                }));
                                closeHeader({ ctx, setShowInfoBlock });
                            }
                        }}
                    >
                        {isDetails ? <BackIcon /> : <CloseIcon />}
                    </IconBtn>
                    <Typography id="se-weather-menu-name" component="div" className={headerStyles.title}>
                        {isDetails ? t('web:forecast_details') : t('shared_string_weather')}
                    </Typography>
                    <Tooltip key={'forecast_source'} title={t('web:forecast_source')} arrow placement="bottom-end">
                        <span>
                            <IconButton
                                id="se-forecast_source"
                                variant="contained"
                                type="button"
                                className={headerStyles.appBarIcon}
                                onClick={(e) => getActions(e, anchorForecastSource, setOpenForecastActions)}
                                ref={anchorForecastSource}
                            >
                                <ForecastSourceIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip key={'weather_layers'} title={t('web:weather_layers')} arrow placement="bottom-end">
                        <span>
                            <IconButton
                                id="se-weather-layers"
                                variant="contained"
                                type="button"
                                className={headerStyles.appBarIcon}
                                onClick={(e) => getActions(e, anchorWeatherLayers, setOpenLayersActions)}
                                ref={anchorWeatherLayers}
                            >
                                <WeatherLayersIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Toolbar>
            </AppBar>
            <ActionsMenu
                open={openForecastActions}
                setOpen={setOpenForecastActions}
                anchorEl={anchorForecastSource}
                actions={<WeatherForecastSourceActions setOpenActions={setOpenForecastActions} />}
            />
            <ActionsMenu
                open={openLayersActions}
                setOpen={setOpenLayersActions}
                anchorEl={anchorWeatherLayers}
                actions={<WeatherLayersActions />}
            />
        </>
    );
}
